// extracted by mini-css-extract-plugin
module.exports = {"root":"EditButton_root__bGMGf","puce":"EditButton_puce__Nz5jA"};